import styled, { css } from 'styled-components';
import { CreateJourneyProps } from './CreateJourney';

export const InnerElement = styled.div<Pick<CreateJourneyProps, 'size'>>`
  ${({ theme, size, ...props }) => {
    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      text-align: center;

      ${size === 'large' &&
      css`
        padding: ${theme.spacing.md};
      `};
    `;
  }};
`;
